// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.S6zL4NMrx5nf2Kkue2ko {
  display: flex;
  flex-wrap: wrap;
}

.ojRRYk4VDIAlqhwabt2d {
  margin-bottom: var(--spacing-small);
}

.ADYnlqeMq7iokxvnvuS8 {
  margin-top: var(--spacing-small);
}

.kOwQvMtsa0BTCINj4b5y {
  margin-top: 10px;
  margin-bottom: var(--spacing-xxSmall);
}

.PfKwNl4nNnayCcCu0z68 {
  white-space: nowrap;
  overflow: hidden;
  padding-left: var(--spacing-xSmall);
  min-width: 154px;
}

.H5i3vB2SqvzM4D3hUTSg {
  padding-left: var(--spacing-xSmall);
  min-width: 154px;
}

.mbTAf1hUWoBnl8Zp8YhY {
  max-width: 70px;
  width: 384px;
  background-color: red;
}

@media screen and (max-width: 768px) {
  .H5i3vB2SqvzM4D3hUTSg {
    padding-left: 0;
  }
}

.uF4j50wFujbkyXqrRFC8 {
  margin-top: var(--spacing-intermediary);
}

.oDgvd7jVSfodDRskvCia {
  margin-top: var(--spacing-xSmall);
  margin-bottom: var(--spacing-xSmall);
}

.Pk1p82op0qH8vxga1RfX {
  display: flex;
  flex-direction: row;
  margin: 0 auto;
}

.EyEfXDFmNdjXIZYXmtj1 {
  align-self: center;
}

.xUfPDaZM77XqD5ZqpCoL {
  margin-bottom: var(--spacing-xxxSmall);
}

.C8sQS8zPkiF8pWcvoFRQ {
  display: flex;
  flex-direction: row;
}

.PqGrx6ZAYQ1kAf71LCTO {
  margin-right: var(--spacing-xSmall);
  align-self: center;
}

.b0RtGOIQ6ap0SQ7YKZU2 {
  width: 80%;
}

.IYu38KCMUYpsBIY0z18i {
  display: flex;
  align-items: center;
}

.IYu38KCMUYpsBIY0z18i > h4 {
  margin-left: var(--spacing-xxxSmall);
}
`, "",{"version":3,"sources":["webpack://./src/App/views/AccessCode/AccessCode.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".row {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.card {\n  margin-bottom: var(--spacing-small);\n}\n\n.cardContent {\n  margin-top: var(--spacing-small);\n}\n\n.label {\n  margin-top: 10px;\n  margin-bottom: var(--spacing-xxSmall);\n}\n\n.button {\n  white-space: nowrap;\n  overflow: hidden;\n  padding-left: var(--spacing-xSmall);\n  min-width: 154px;\n}\n\n.buttons {\n  padding-left: var(--spacing-xSmall);\n  min-width: 154px;\n}\n\n.dialogWidth {\n  max-width: 70px;\n  width: 384px;\n  background-color: red;\n}\n\n@media screen and (max-width: 768px) {\n  .buttons {\n    padding-left: 0;\n  }\n}\n\n.cardAccessCode {\n  margin-top: var(--spacing-intermediary);\n}\n\n.divider {\n  margin-top: var(--spacing-xSmall);\n  margin-bottom: var(--spacing-xSmall);\n}\n\n.usedCodesDiv {\n  display: flex;\n  flex-direction: row;\n  margin: 0 auto;\n}\n\n.itemImage {\n  align-self: center;\n}\n\n.usedOn {\n  margin-bottom: var(--spacing-xxxSmall);\n}\n\n.codeContainer {\n  display: flex;\n  flex-direction: row;\n}\n\n.codeImage {\n  margin-right: var(--spacing-xSmall);\n  align-self: center;\n}\n\n.codeInfo {\n  width: 80%;\n}\n\n.dialogTitle {\n  display: flex;\n  align-items: center;\n}\n\n.dialogTitle > h4 {\n  margin-left: var(--spacing-xxxSmall);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `S6zL4NMrx5nf2Kkue2ko`,
	"card": `ojRRYk4VDIAlqhwabt2d`,
	"cardContent": `ADYnlqeMq7iokxvnvuS8`,
	"label": `kOwQvMtsa0BTCINj4b5y`,
	"button": `PfKwNl4nNnayCcCu0z68`,
	"buttons": `H5i3vB2SqvzM4D3hUTSg`,
	"dialogWidth": `mbTAf1hUWoBnl8Zp8YhY`,
	"cardAccessCode": `uF4j50wFujbkyXqrRFC8`,
	"divider": `oDgvd7jVSfodDRskvCia`,
	"usedCodesDiv": `Pk1p82op0qH8vxga1RfX`,
	"itemImage": `EyEfXDFmNdjXIZYXmtj1`,
	"usedOn": `xUfPDaZM77XqD5ZqpCoL`,
	"codeContainer": `C8sQS8zPkiF8pWcvoFRQ`,
	"codeImage": `PqGrx6ZAYQ1kAf71LCTO`,
	"codeInfo": `b0RtGOIQ6ap0SQ7YKZU2`,
	"dialogTitle": `IYu38KCMUYpsBIY0z18i`
};
export default ___CSS_LOADER_EXPORT___;
